import { LineStatus } from './enums';
import { CompressedOrderShipment } from './compressed-order-shipment';
import { OrderShipmentGroup } from '.';
import { CompressedOrderShipmentGroupsList } from './compressed-order-shipment-groups-list';

export class CompressedOrderShipmentGroup {
  status: LineStatus;
  orderShipments: CompressedOrderShipment[];

  /**
   * Convert a CompressedOrderShipmentGroup to an OrderShipmentGroup for use in the rest of Insight. 
   * @param compressedOrderShipmentGroupsList  The CompressedOrderShipmentGroupsList that this CompressedOrderShipmentGroup belongs to.
   * @param compressedGroup The CompressedOrderShipmentGroup.
   * @returns The OrderShipmentGroup.
   */
  static toOrderShipmentGroup(compressedOrderShipmentGroupsList: CompressedOrderShipmentGroupsList, compressedGroup: CompressedOrderShipmentGroup): OrderShipmentGroup {
    let orderShipmentGroup = new OrderShipmentGroup();
    orderShipmentGroup.status = compressedGroup.status;
    orderShipmentGroup.orderShipments = compressedGroup.orderShipments.map((compressedShipment: CompressedOrderShipment) => CompressedOrderShipment.toOrderShipment(compressedOrderShipmentGroupsList, compressedShipment));
    return orderShipmentGroup;
  }
}
